angular
    .module('app')
    .component('customerControl', {
        template: require('./customer-control.html'),
        controller: ['$uibModal', controller],
        bindings: {
            organization: '<',
        }
    });

function controller($uibModal) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        console.log($ctrl.organization);
    };

    $ctrl.openOrganizationInfo = () => {
        $uibModal.open({
            component: 'organizationInfo',
            resolve: {
                organization() {
                    return $ctrl.organization;
                }
            }
        })
    };

    $ctrl.sendInvite = () => {
        $uibModal.open({
            component: 'organizationInviteForm',
            resolve: {
                organization() {
                    return $ctrl.organization;
                }
            }
        })
    };
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/customer-control/customer-control.js